import { Bell } from 'lucide-react';
import { useNotifications } from '@/hooks/useNotifications';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import {
  NotificationsDropdown,
} from './NotificationsDropdown';

export const NotificationBadge = () => {
  const { unreadCount } = useNotifications();

  return (
    <div className="relative">
      <NotificationsDropdown>
        <Button
          variant="ghost"
          size="sm"
          className="relative"
          aria-label={`${unreadCount} notificações não lidas`}
        >
          <Bell className="size-5" />
          {unreadCount > 0 && (
            <Badge
              variant="destructive"
              className="absolute -top-1 -right-1 size-5 flex items-center justify-center p-0 text-xs"
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </Badge>
          )}
        </Button>
      </NotificationsDropdown>
    </div>
  );
};

